import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["editMode", "options", "multiple", "value", "classes", "showBlank", "excludedOptions", "forceNoTypeahead", "useRevampedMapItemToChip", "onChange", "prefixSelectedOption"],
  _excluded2 = ["classes", "value", "name", "options", "SelectProps", "onChange", "onBlur", "showBlank", "id", "placeholder", "displayEmpty", "SelectDisplayProps", "InputLabelProps", "label", "useClearIcon", "prefixSelectedOption"],
  _excluded3 = ["value", "name", "onChange", "options", "classes", "onBlur", "SelectProps"];
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.function.name.js";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context2, _context3; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(t), !0)).call(_context2, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context3 = ownKeys(Object(t))).call(_context3, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";
//@ts-nocheck
import React from "react";
import { Checkbox, ListItemText, MenuItem, Select, withStyles, Typography, InputAdornment } from "components/mui";
import FieldBase from "componentLibrary/Fields/FieldBase";
import SelectChip from "./SelectChip";
import AutoCompleteSelectInput from "./AutoCompleteSelectInput";
import { IconConstants, RaiseColors, IconButton, Icon } from "componentLibrary";
import { OVERLAY_MENU_Z_INDEX } from "utils/constants";

/*
 * Taken from https://material-ui.com/demos/selects/
 */
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default withStyles(function (theme) {
  return {
    formControl: {},
    chips: {
      display: "flex",
      flexWrap: "wrap"
    },
    multiSelect: {
      paddingTop: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingBottom: 0
    }
  };
})(SelectField);
function SelectField(_ref) {
  var _ref$editMode = _ref.editMode,
    editMode = _ref$editMode === void 0 ? true : _ref$editMode,
    options = _ref.options,
    multiple = _ref.multiple,
    value = _ref.value,
    classes = _ref.classes,
    showBlank = _ref.showBlank,
    excludedOptions = _ref.excludedOptions,
    _ref$forceNoTypeahead = _ref.forceNoTypeahead,
    forceNoTypeahead = _ref$forceNoTypeahead === void 0 ? false : _ref$forceNoTypeahead,
    useRevampedMapItemToChip = _ref.useRevampedMapItemToChip,
    onChange = _ref.onChange,
    _ref$prefixSelectedOp = _ref.prefixSelectedOption,
    prefixSelectedOption = _ref$prefixSelectedOp === void 0 ? "" : _ref$prefixSelectedOp,
    props = _objectWithoutProperties(_ref, _excluded);
  var conformedValue = value;
  if (multiple && !_Array$isArray(value)) {
    conformedValue = value ? [value] : [];
    console.error("Passing a single value using multiple select, expecting an array!");
  }
  if (options.length > 10 && editMode && !forceNoTypeahead) {
    return /*#__PURE__*/_jsx(AutoCompleteSelectInput, _objectSpread({
      options: options,
      value: value,
      multiple: multiple,
      excludedOptions: excludedOptions,
      useRevampedMapItemToChip: useRevampedMapItemToChip,
      onChange: onChange
    }, props));
  }
  if (editMode && multiple) {
    return /*#__PURE__*/_jsx(MultiSelectField, _objectSpread({
      value: conformedValue,
      options: options,
      classes: classes,
      onChange: onChange
    }, props));
  } else if (editMode) {
    return /*#__PURE__*/_jsx(SingleSelectField, _objectSpread({
      value: conformedValue,
      options: options,
      classes: classes,
      showBlank: showBlank,
      onChange: onChange,
      prefixSelectedOption: prefixSelectedOption
    }, props));
  } else if (multiple) {
    var getLabel = function getLabel(item) {
      var _options$find$label;
      return (_options$find$label = _findInstanceProperty(options).call(options, function (o) {
        return o.value === item;
      }).label) !== null && _options$find$label !== void 0 ? _options$find$label : "";
    };
    return _mapInstanceProperty(conformedValue).call(conformedValue, getLabel).join(", ");
  }
  var option = _findInstanceProperty(options).call(options, function (o) {
    return o.value === value;
  });
  return option ? option.label : "";
}
function SingleSelectField(_ref2) {
  var _context;
  var classes = _ref2.classes,
    value = _ref2.value,
    name = _ref2.name,
    options = _ref2.options,
    _ref2$SelectProps = _ref2.SelectProps,
    SelectProps = _ref2$SelectProps === void 0 ? {} : _ref2$SelectProps,
    onChange = _ref2.onChange,
    _ref2$onBlur = _ref2.onBlur,
    onBlur = _ref2$onBlur === void 0 ? function () {} : _ref2$onBlur,
    _ref2$showBlank = _ref2.showBlank,
    showBlank = _ref2$showBlank === void 0 ? false : _ref2$showBlank,
    id = _ref2.id,
    placeholder = _ref2.placeholder,
    displayEmpty = _ref2.displayEmpty,
    _ref2$SelectDisplayPr = _ref2.SelectDisplayProps,
    SelectDisplayProps = _ref2$SelectDisplayPr === void 0 ? {} : _ref2$SelectDisplayPr,
    InputLabelProps = _ref2.InputLabelProps,
    label = _ref2.label,
    _ref2$useClearIcon = _ref2.useClearIcon,
    useClearIcon = _ref2$useClearIcon === void 0 ? false : _ref2$useClearIcon,
    _ref2$prefixSelectedO = _ref2.prefixSelectedOption,
    prefixSelectedOption = _ref2$prefixSelectedO === void 0 ? "" : _ref2$prefixSelectedO,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var showClearIcon = useClearIcon && value && value !== "";
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(FieldBase, _objectSpread(_objectSpread({
      className: classes.formControl,
      id: id,
      label: label,
      InputLabelProps: _objectSpread({
        style: {
          position: "static"
        }
      }, InputLabelProps)
    }, props), {}, {
      children: /*#__PURE__*/_jsxs(Select, _objectSpread(_objectSpread(_objectSpread({
        sx: _objectSpread({
          backgroundColor: RaiseColors.white,
          border: "none",
          borderRadius: "8px",
          color: RaiseColors.black,
          "& .MuiSelect-select": {
            fontSize: "14px"
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: RaiseColors.grayscale200
          }
        }, displayEmpty && (!value || value === "") && {
          "& .MuiSelect-select": {
            fontSize: "14px",
            color: RaiseColors.grayscale900
          }
        }),
        MenuProps: _objectSpread({
          disablePortal: false,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "center"
          },
          fontSize: "14px",
          sx: {
            fontSize: "14px",
            zIndex: OVERLAY_MENU_Z_INDEX
          },
          PaperProps: {
            sx: {
              borderRadius: "16px",
              marginTop: "8px"
            }
          }
        }, SelectProps.MenuProps || {}),
        value: value || "",
        name: name,
        onChange: onChange,
        onBlur: onBlur,
        SelectDisplayProps: _objectSpread({
          "aria-label": !props.label && placeholder ? placeholder : null
        }, SelectDisplayProps),
        displayEmpty: displayEmpty,
        labelId: id // https://material-ui.com/components/selects/#accessibility
        ,
        id: " " // otherwise MUI generates an aria-labelled-by and id value to the div holding the current value and it's breaking some tests
      }, SelectProps), props), {}, {
        renderValue: function renderValue(selected) {
          // When displayEmpty is true and no value is selected, show placeholder
          if (displayEmpty && (!selected || selected === "")) {
            return /*#__PURE__*/_jsx("span", {
              style: {
                color: RaiseColors.grayscale900
              },
              children: placeholder
            });
          }
          // Otherwise, find and return the selected option's label
          var selectedOption = _findInstanceProperty(options).call(options, function (option) {
            return option.value === selected;
          });
          var finalLabel = selectedOption ? selectedOption.label : selected;
          if (prefixSelectedOption) {
            finalLabel = /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsxs("span", {
                style: {
                  color: RaiseColors.grayscale900
                },
                children: [prefixSelectedOption, " "]
              }), finalLabel]
            });
          }
          return finalLabel;
        },
        endAdornment: showClearIcon ? /*#__PURE__*/_jsx(InputAdornment, {
          sx: {
            position: "absolute",
            backgroundColor: RaiseColors.white,
            width: "20px",
            height: "15px",
            right: "5px"
          },
          position: "end",
          children: /*#__PURE__*/_jsx(IconButton, {
            sx: {
              width: "27px",
              height: "27px"
            },
            onClick: function onClick(e) {
              e.stopPropagation();
              onChange({
                target: {
                  value: null,
                  name: name
                }
              });
            },
            children: /*#__PURE__*/_jsx(Icon, {
              className: IconConstants.X,
              fontSize: 16,
              color: RaiseColors.grayscale900
            })
          })
        }) : null,
        children: [placeholder && /*#__PURE__*/_jsx(MenuItem, {
          value: "",
          disabled: true,
          children: placeholder
        }), _mapInstanceProperty(_context = _filterInstanceProperty(options).call(options, function (option) {
          if (showBlank) {
            return true;
          }
          return option.value !== "";
        })).call(_context, function (option, index) {
          return /*#__PURE__*/_jsx(MenuItem, {
            value: option.value,
            children: option.value === "" ? /*#__PURE__*/_jsx("span", {
              style: {
                visibility: "hidden"
              },
              children: "nothing"
            }) : /*#__PURE__*/_jsx(ListItemText, {
              disableTypography: true,
              primary: option.label,
              secondary: /*#__PURE__*/_jsx(_Fragment, {
                children: option.description ? /*#__PURE__*/_jsx(Typography, {
                  component: "p",
                  variant: "paragraph_xsmall",
                  color: RaiseColors.gray300,
                  children: option.description
                }) : null
              })
            })
          }, index);
        })]
      }))
    }))
  });
}
function MultiSelectField(_ref3) {
  var value = _ref3.value,
    name = _ref3.name,
    onChange = _ref3.onChange,
    options = _ref3.options,
    classes = _ref3.classes,
    _ref3$onBlur = _ref3.onBlur,
    onBlur = _ref3$onBlur === void 0 ? function () {} : _ref3$onBlur,
    _ref3$SelectProps = _ref3.SelectProps,
    SelectProps = _ref3$SelectProps === void 0 ? {} : _ref3$SelectProps,
    props = _objectWithoutProperties(_ref3, _excluded3);
  var multiselectClasses = {
    select: classes.multiSelect
  };
  if (value.length === 0) {
    // don't set any styles so that empty multi-select has width
    multiselectClasses = {};
  }
  return /*#__PURE__*/_jsx(FieldBase, _objectSpread(_objectSpread({
    className: classes.formControl
  }, props), {}, {
    children: /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread(_objectSpread({
      style: {
        height: "100%",
        padding: "8px 24px 8px 16px",
        minHeight: "36px",
        textAlign: "left",
        "& .MuiListItemText-root": {
          marginTop: 0,
          marginBottom: 0
        }
      },
      MenuProps: _objectSpread({
        disablePortal: false,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center"
        },
        sx: {
          zIndex: OVERLAY_MENU_Z_INDEX
        }
      }, SelectProps.MenuProps || {}),
      multiple: true,
      value: value,
      name: name,
      onChange: onChange,
      onClose: onBlur,
      classes: _objectSpread(_objectSpread({}, multiselectClasses), SelectProps.classes),
      renderValue: function renderValue(selected) {
        return /*#__PURE__*/_jsx("div", {
          className: classes.chips,
          children: _mapInstanceProperty(selected).call(selected, function (value) {
            var selectedOption = _findInstanceProperty(options).call(options, function (o) {
              return o.value === value;
            });
            return /*#__PURE__*/_jsx(SelectChip, {
              className: "select-chip",
              label: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label
            }, value);
          })
        });
      }
    }, SelectProps), props), {}, {
      children: _mapInstanceProperty(options).call(options, function (option) {
        return /*#__PURE__*/_jsxs(MenuItem, {
          value: option.value,
          children: [/*#__PURE__*/_jsx(Checkbox, {
            checked: _indexOfInstanceProperty(value).call(value, option.value) > -1
          }), /*#__PURE__*/_jsx(ListItemText, {
            primary: option.label
          })]
        }, option.value);
      })
    }))
  }));
}